import styled from 'styled-components';

import { ButtonLink } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Heading = styled.div`
  font-weight: ${fontWeight('bold')};
  ${fontStyle('xl')};
  line-height: 23px;

  color: ${({ theme }) => theme.colors.darkBackground};
  margin-bottom: ${spacing('xl')};
  display: flex;
  align-items: center;
`;

export const $PaymentLabel = styled.div`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('medium')};
`;

export const $ButtonLink = styled(ButtonLink)`
  width: auto;
  text-decoration: unset;
  margin-top: ${spacing('xl')};
`;
